export default "__VITE_ASSET__DjPGktq1__"